import React from 'react';
import './GameCard.css';

interface GameCardProps {
  title: string;
  description: string;
  icon: string;
  onClick: () => void;
  difficulty?: 'Easy' | 'Medium' | 'Hard';
  features?: string[];
}

const GameCard: React.FC<GameCardProps> = ({ 
  title, 
  description, 
  icon, 
  onClick, 
  difficulty = 'Easy',
  features = []
}) => {
  return (
    <div className="game-card" onClick={onClick}>
      <div className="game-card-header">
        <div className="game-icon">{icon}</div>
        <div className="game-info">
          <h3>{title}</h3>
          <span className={`difficulty-badge ${difficulty.toLowerCase()}`}>
            {difficulty}
          </span>
        </div>
      </div>
      
      <div className="game-card-body">
        <p>{description}</p>
        {features.length > 0 && (
          <div className="game-features">
            {features.map((feature, index) => (
              <span key={index} className="feature-tag">
                {feature}
              </span>
            ))}
          </div>
        )}
      </div>
      
      <div className="game-card-footer">
        <button className="play-button">
          ▶️ Play Now
        </button>
      </div>
    </div>
  );
};

export default GameCard;
